<template>
  <div>
    <div class="step1 mb-2">
      <div class="activeicon">
        <p class="font-semibold text-base text-dark mb-2">
          {{ $t('frontend_groovemail_sequences_automation_delay') }}
        </p>
      </div>
      <div class="flex flex-no-wrap flex-col mb-4">
        <div class="w-full" v-for="(option, index) in stepoptions" :key="index">
          <div class="flex">
            <div class="w-full sequence-radio">
              <gd-custom-radio
                class=""
                :option="option"
                value="localModel.timedelayoption"
                v-model="localModel.timedelayoption"
              ></gd-custom-radio>
            </div>
          </div>
        </div>
      </div>
      <div class="waitdate" v-if="localModel.timedelayoption == 3">
        <div class="flex flex-col mb-6">
          <label class="font-semibold text-dark mb-2">
            {{ $t('frontend_groovemail_sequences_delay_wait_until') }}
          </label>
          <div class="relative">
            <div
              class="absolute z-50 pointer-events-none"
              style="right: 15px; top: 9px"
            >
              <CalenderIcon class="text-grey-500 h-5 w-5" />
            </div>
            <DateTimePicker
              v-model="localModel.timedelaydate"
              variant="base"
              :picker="'datetime'"
              :timeZone="'UTC'"
              :zone="'America/New_York'"
              :minDatetime="new Date().toISOString()"
            />
          </div>
          <div class="mt-2">
            <p class="text-sm font-bold text-danger">
              {{
                $t(
                  'frontend_groovemail_all_emails_to_be_scheduled_in_est_timezone'
                )
              }}
            </p>
          </div>
        </div>
      </div>
      <div class="waithour" v-else-if="localModel.timedelayoption == 2">
        <div class="flex mb-6 flex-col flex-wrap">
          <p class="font-semibold text-dark mb-2">
            {{ $t('frontend_groovemail_sequences_delay_wait_for') }}
          </p>
          <div class="flex wait-inputs flex-row flex-wrap">
            <div class="w-2/5">
              <text-input
                class="mb-1"
                variant="base"
                v-model="localModel.timedelaydays"
                :placeholder="$t('frontend_analytics_days')"
              />
              <span class="w-full text-sm">
                {{ $t('frontend_groovemail_sequences_automation_days') }}
              </span>
            </div>
            <p class="w-1/5 text-center">&</p>
            <div class="w-2/5 relative">
              <DownIcon
                class="h-5 w-5 absolute right-2 text-grey-600 top-2.5"
              />
              <select
                class="w-full h-10 rounded-lg text-sm border border-grey-200 text-dark bg-white pl-3 pr-7 appearance-none mb-1"
                v-model="localModel.timedelayhours"
              >
                <option value="0">0</option>
                <option v-for="n in 23" :value="n" :key="n">{{ n }}</option>
              </select>
              <span class="w-full text-sm">
                {{ $t('frontend_groovemail_sequences_automation_hours') }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div
        class="waitdate"
        v-if="[4, 5, 6].includes(localModel.timedelayoption)"
      >
        <div class="flex flex-col mb-6">
          <div class="flex">
            <div class="w-full">
              <div>
                <div class="w-full">
                  <label
                    class="
                      flex
                      items-center
                      font-semibold
                      flex
                      text-base text-dark
                      mb-2
                    "
                  >
                    <span class="mr-1">
                      {{
                        $t('frontend_groovemail_sequences_delay_dynamic_date')
                      }}
                    </span>
                    <button
                      v-tooltip="{
                        content: $t(
                          'frontend_add_dynamic_variables_to_this_field'
                        ),
                        placement: 'right-start',
                        classes: ['info'],
                        targetClasses: ['it-has-a-tooltip'],
                        offset: 10,
                        delay: {
                          show: 200,
                          hide: 300
                        }
                      }"
                    >
                      <InfoIcon class="text-grey-600 h-4 w-4" />
                    </button>
                  </label>
                </div>

                <div class="w-full relative">
                  <text-input
                    variant="base"
                    v-model="localModel.timedelaydate"
                  />
                  <div
                    v-click-outside="closeSubjectVariables"
                    class="plus-round-icon bg-primary absolute"
                    style="right: 8px; top: 8px"
                    @click="openSubjectVariables"
                  >
                    <div
                      class="
                        bg-white
                        btn-radius
                        py-6
                        pl-6
                        absolute
                        overflow-auto
                      "
                      style="
                        width: 290px;
                        right: -10px;
                        bottom: 35px;
                        z-index: 100;
                        box-shadow: 20px 20px 40px 0 rgba(22, 29, 37, 0.05);
                      "
                      v-if="showSubjectDropdown"
                    >
                      <div class="pr-6">
                        <text-input
                          variant="base"
                          v-model="emailSubjectVariableSearch"
                          @input="changedEmailSubjectSearchVariable"
                          :placeholder="
                            $t('frontend_groovemail_tables_search_query')
                          "
                        >
                          <SearchIcon slot="prependIcon" />
                        </text-input>
                      </div>
                      <VuePerfectScrollbar>
                        <div
                          class="mt-6 text-sm font-semibold"
                          style="max-height: 160px"
                        >
                          <div
                            class="mb-6"
                            v-for="(option,
                            index) in dynamic_variables_sms_content_subject"
                            :key="index"
                          >
                            <div
                              class="cursor-pointer text-grey-700 text-left"
                              @click="copyVariableInSubject(option)"
                            >
                              {{ option.label }}
                            </div>
                          </div>
                        </div>
                      </VuePerfectScrollbar>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-2">
            <p class="text-sm font-bold text-danger">
              {{
                $t(
                  'frontend_groovemail_all_emails_to_be_scheduled_in_est_timezone'
                )
              }}
            </p>
          </div>
        </div>
        <div
          class="flex mb-6 flex-col flex-wrap"
          v-if="[5, 6].includes(localModel.timedelayoption)"
        >
          <p
            class="font-semibold text-dark mb-2"
            v-if="localModel.timedelayoption == 5"
          >
            {{ $t('frontend_groovemail_sequences_delay_time_before') }}
          </p>
          <p
            class="font-semibold text-dark mb-2"
            v-if="localModel.timedelayoption == 6"
          >
            {{ $t('frontend_groovemail_sequences_delay_time_after') }}
          </p>
          <div class="flex wait-inputs flex-row flex-wrap">
            <div class="w-2/5">
              <text-input
                class="mb-1"
                variant="base"
                v-model="localModel.timedelaydays"
                :placeholder="$t('frontend_analytics_days')"
              />
              <span class="w-full text-sm">
                {{ $t('frontend_groovemail_sequences_automation_days') }}
              </span>
            </div>
            <p class="w-1/5 text-center">&</p>
            <div class="w-2/5 relative">
              <DownIcon
                class="h-5 w-5 absolute right-2 text-grey-600 top-2.5"
              />
              <select
                class="w-full h-10 rounded-lg text-sm border border-grey-200 text-dark bg-white pl-3 pr-7 appearance-none mb-1"
                v-model="localModel.timedelayhours"
              >
                <option value="0">0</option>
                <option v-for="n in 23" :value="n" :key="n">{{ n }}</option>
              </select>
              <span class="w-full text-sm">
                {{ $t('frontend_groovemail_sequences_automation_hours') }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DateTimePicker from '@groovepages/gd-ui-kit/components/DateTimePicker';

// import icons
import DownIcon from '@/assets/images/icons/new/down_new.svg';
import CalenderIcon from '@/assets/images/icons/new/calendar_days_new.svg';
import InfoIcon from '@/assets/images/icons/new/info_new.svg';
import SearchIcon from '@/assets/images/icons/new/search_new.svg';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import dynamicVariableFieldMixin from '@/mixin/dynamicVariableFieldMixin';
import ClickOutside from 'vue-click-outside';

export default {
  name: 'DelayNode',
  props: {
    model: {
      required: true
    }
  },
  directives: {
    ClickOutside
  },

  data() {
    return {
      localModel: this.model
    };
  },

  computed: {
    timeoptions() {
      return [
        {
          id: 1,
          title: this.$t(
            'frontend_groovemail_sequence_delay_time_option_anytime_day'
          ),
          placeholder: this.$t(
            'frontend_groovemail_sequence_delay_time_option_anytime_day'
          )
        },
        {
          id: 2,
          title: this.$t(
            'frontend_groovemail_sequence_delay_time_option_between'
          ),
          placeholder: this.$t(
            'frontend_groovemail_sequence_delay_time_option_between'
          )
        }
      ];
    },
    daysoptions() {
      return [
        {
          id: 1,
          title: this.$t('frontend_groovemail_monday_long'),
          placeholder: this.$t('frontend_groovemail_monday_long'),
          value: true
        },
        {
          id: 2,
          title: this.$t('frontend_groovemail_tuesday_long'),
          placeholder: this.$t('frontend_groovemail_tuesday_long'),
          value: true
        },
        {
          id: 3,
          title: this.$t('frontend_groovemail_wednesday_long'),
          placeholder: this.$t('frontend_groovemail_wednesday_long'),
          value: true
        },
        {
          id: 4,
          title: this.$t('frontend_groovemail_thursday_long'),
          placeholder: this.$t('frontend_groovemail_thursday_long'),
          value: true
        },
        {
          id: 5,
          title: this.$t('frontend_groovemail_friday_long'),
          placeholder: this.$t('frontend_groovemail_friday_long'),
          value: true
        },
        {
          id: 6,
          title: this.$t('frontend_groovemail_saturday_long'),
          placeholder: this.$t('frontend_groovemail_saturday_long'),
          value: true
        },
        {
          id: 7,
          title: this.$t('frontend_groovemail_sunday_long'),
          placeholder: this.$t('frontend_groovemail_sunday_long'),
          value: true
        }
      ];
    },
    stepoptions() {
      return [
        {
          id: 1,
          title: this.$t('frontend_groovemail_sequences_showdetail_right'),
          placeholder: this.$t(
            'frontend_groovemail_sequences_showdetail_right'
          ),
          checked: 'checked'
        },
        {
          id: 2,
          title: this.$t(
            'frontend_groovemail_sequence_delay_step_option_wait_days'
          ),
          placeholder: this.$t(
            'frontend_groovemail_sequence_delay_step_option_wait_days'
          )
        },
        {
          id: 3,
          title: this.$t(
            'frontend_groovemail_sequence_delay_step_option_wait_date'
          ),
          placeholder: this.$t(
            'frontend_groovemail_sequence_delay_step_option_wait_date'
          )
        },
        {
          id: 4,
          title: this.$t(
            'frontend_groovemail_sequence_delay_step_option_wait_dynamic_date'
          ),
          placeholder: this.$t(
            'frontend_groovemail_sequence_delay_step_option_wait_dynamic_date'
          )
        },
        {
          id: 5,
          title: this.$t(
            'frontend_groovemail_sequence_delay_step_option_days_hours_before_dynamic_date'
          ),
          placeholder: this.$t(
            'frontend_groovemail_sequence_delay_step_option_days_hours_before_dynamic_date'
          )
        },
        {
          id: 6,
          title: this.$t(
            'frontend_groovemail_sequence_delay_step_option_days_hours_after_dynamic_date'
          ),
          placeholder: this.$t(
            'frontend_groovemail_sequence_delay_step_option_days_hours_after_dynamic_date'
          )
        }
      ];
    }
  },

  mixins: [dynamicVariableFieldMixin],

  components: {
    VuePerfectScrollbar,
    InfoIcon,
    DateTimePicker,
    DownIcon,
    CalenderIcon,
    SearchIcon
  },

  watch: {
    localModel() {
      this.$emit('updateModel', this.localModel);
    },

    'localModel.timedelayoption': function watchTimeDelayOption() {
      if (this.localModel.timedelayoption === 3) {
        this.localModel.timedelaydate = new Date().toISOString();
        // }else if ([4, 5, 6].includes(this.localModel.timedelayoption)) {
        // this.localModel.timedelaydate = '';
      } else {
        this.localModel.timedelaydate = '';
      }
    }
  }
};
</script>

<style lang="scss">
// .seq-radio {
//   .items-left {
//     padding: 3.5px 12px !important;
//   }

//   label {
//     font-weight: 400 !important;

//     span {
//       width: 13px;
//       height: 12px;
//     }
//   }

//   > div {
//     margin-bottom: 8px;
//   }
// }

// .seq-checkbox {
//   > div {
//     > span {
//       width: 20px;
//       height: 20px;
//       border-radius: 3px;
//       > svg {
//         width: 10px;
//       }
//     }
//   }
// }

.waitdate {
  input {
    border-radius: 8px;
  }
}

.sequence-radio {
  .border.p-2 {
    border: none;
    padding: 0;
  }

  .w-6 {
    height: 22px;
    margin: 0;
  }

  .font-semibold {
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
    margin-left: 4px;
  }
}
</style>
